import React, { Component } from 'react';
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import * as residenceActions from "../../actions/acResidences"

import PootsySelectInput from "./PootsySelectInput"
import { PootsyCheckboxInput, PootsyTextInput } from "../InputsFunctions"
import InputsChangeHandler from "../InputsChangeHandler";


class NewResidenceForm extends Component {

	componentDidMount = () => {
		if (this.props.residenceSuggestion !== undefined) {
			this.props.dispatch(residenceActions.prefillNewResidence(this.props.residenceSuggestion))
		}
	}

	render() {
		let { t } = this.context
		let { newResidence, errors } = this.props

		return (
			<InputsChangeHandler customClass="NewResidenceForm" onChange={this.handleFormChanges}>
				{this.renderResidenceTypeSelect()}
				<div className="street-container">
					<PootsyTextInput label={t('common_street_name')}
									 customClass="name"
									 name="streetName"
									 showError={t(errors['address_street'])}
									 value={newResidence.streetName}
					/>
					<PootsyTextInput label={t('common_street_number')}
									 customClass="number"
									 name="streetNumber"
									 showError={t(errors['address_street_number'])}
									 value={newResidence.streetNumber}
					/>
					<PootsyTextInput label={t('common_street_box')}
									 customClass="box"
									 name="streetBox"
									 showError={t(errors['address_street_box'])}
									 value={newResidence.streetBox}
					/>
				</div>

				<div className="zip-city-container">
					<PootsyTextInput label={t('common_zip_code')}
									 customClass="zip-code"
									 name="zipCode"
									 showError={t(errors['address_zip_code'])}
									 value={newResidence.zipCode}
					/>
					<PootsyTextInput label={t('common_city')}
									 customClass="city"
									 name="city"
									 showError={t(errors['address_town'])}
									 value={newResidence.city}
					/>
				</div>
				<div className="surface-container">
					<PootsyTextInput label={t('common_surface')}
									 name="surface"
									 showError={t(errors['address_surface'])}
									 value={newResidence.surface}
					/>
					<div className="type">{t('common_m2')}</div>
				</div>

				<div className="common-info-container">
					<PootsyTextInput
						label={t('common_other_info')}
						name="otherInfo"
						customClass="otherInfo"
						value={newResidence.otherInfo}
					/>
				</div>

				<div className="get-in-container">
					<PootsyTextInput
						label={t('common_how_to_get_in')}
						name="howToGetIn"
						customClass="howToGetIn"
						value={newResidence.howToGetIn}
					/>
				</div>

				<PootsyCheckboxInput
					label={t('common_i_have_a_pet')}
					name="hasPets"
					checked={newResidence.hasPets}
				/>
			</InputsChangeHandler>
		)
	}

	renderResidenceTypeSelect = () => {
		let { t } = this.context

		let options = [
			{
				value: 'house',
				label: t('common_housing_type_house')
			},
			{
				value: 'apartment',
				label: t('common_housing_type_apartment')
			},
			{
				value: 'other',
				label: t('common_housing_type_other')
			}
		]

		return (

			<PootsySelectInput
				label={t('booking_flow_housing_type')}
				options={options}
				selectedValue={this.props.newResidence.type ? this.props.newResidence.type : 0}
				onChange={this.onResidenceTypeChanged}/>
		)
	}


	handleFormChanges = changes => {
		this.updateNewResidence(changes)
	}

	onResidenceTypeChanged = (option) => {
		this.updateNewResidence({ type: option.value })
	}

	updateNewResidence = (changes) => {
		this.props.dispatch(residenceActions.updateNewResidence(changes))
	}
}

NewResidenceForm.contextTypes = { t: PropTypes.func }
const mapStateToProps = state => ({
	newResidence: state.dataReducer.residences.newResidence,
	errors: state.metadataReducer.residences.form_errors,
})
export default connect(mapStateToProps)(NewResidenceForm);


// WEBPACK FOOTER //
// ./src/components/shared/NewResidenceForm.js